import { Component, Fragment, h, Prop, Watch } from '@stencil/core';

interface BreadcrumbItem {
  title: string;
  url?: string;
}

export interface UiCmsBreadcrumbBody {
  site: {
    pages?: BreadcrumbItem[];
  } & BreadcrumbItem;
}

@Component({
  tag: 'ui-cms-breadcrumb',
  styleUrl: 'ui-cms-breadcrumb.scss',
})
export class UiCmsBreadcrumb {
  @Prop({ mutable: true }) body: UiCmsBreadcrumbBody;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  onClick(breadcrumbItem: BreadcrumbItem) {
    const elementLabel = breadcrumbItem.title.replace(' ', '_'); // match spaceless format in previous tracking interface
    const trackingEvent = {
      eventInfo: {
        eventName: 'Breadcrumb Click',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Link',
        elementLabel,
      },
      category: {
        area: 'Navigation',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  breadcrumbList!: HTMLOListElement;

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  componentDidLoad() {
    /*
     * This is only needed if we have a touch device, but it's not a problem if we don't
     * We have a scrolling element for touch devices as they can't hover to expand breadcrum items
     * To show the current element and make it more "breadcrumby", we scroll to the last element
     */

    this.breadcrumbList?.lastElementChild?.scrollIntoView({ block: 'end' });
  }

  render() {
    return (
      <sd-breadcrumb>
        {this.body?.site && (
          <Fragment>
            {this.body.site.pages?.map((breadcrumbItem, index) => {
              const isLast = index === (this.body.site?.pages?.length || 0) - 1;

              return (
                <sd-breadcrumb-item
                  key={`breadcrumb-${index}`}
                  href={!isLast && breadcrumbItem.url ? breadcrumbItem.url : undefined}
                  onClick={breadcrumbItem.url ? () => this.onClick(breadcrumbItem) : undefined}
                  current={isLast}
                >
                  {breadcrumbItem.title}
                </sd-breadcrumb-item>
              );
            })}
          </Fragment>
        )}
      </sd-breadcrumb>
    );
  }
}
